import { css } from '@linaria/core';
import { styled } from '@linaria/react';
import { breakpoints, colors, Text, zIndex } from '@spaceshipapp/cambridge';

export const ctaStyle = css`
  padding: 0;
  text-decoration: none;
  color: ${colors.subtext};
`;

export const modalStyle = css`
  display: flex;
  flex-direction: column;
  position: fixed;
  bottom: 0;
  z-index: ${zIndex.MODAL + 1};
  @media (min-width: ${breakpoints.md}) {
    top: 50%;
    left: 50%;
    max-width: 24rem;

    bottom: auto;
    transform: translate(-50%, -50%);
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: 60vh;

  > *:not(:first-child) {
    margin-top: 1rem;
  }
`;

export const buttonStyle = css`
  min-width: 10rem;
  margin: 0 auto;
  text-decoration: none;
`;

export const textStyle = css`
  text-align: center;
`;

export const SubText = styled.a`
  text-decoration: none;
  color: ${colors.highlight60};
`;

export const ImgContainer = styled.div`
  height: 8.625rem;
`;
